import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from "../SnackBar";

export const SECRETARY_PATCH_REQUEST = 'PATCH_SECRETARY_REQUEST';
export const SECRETARY_PATCH_FAILURE = 'PATCH_SECRETARY_FAILURE';
export const SECRETARY_PATCH_SUCCESS = 'PATCH_SECRETARY_SUCCESS';

export const patchSecretary = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.SECRETARY.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Secretary successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => {
    return { type: SECRETARY_PATCH_REQUEST }
};

const postFailure = (error) => {
    return { type: SECRETARY_PATCH_FAILURE, error }
};

const patchSuccess = secretary => {
    return { type: SECRETARY_PATCH_SUCCESS, secretary }
};